<template>
  <div id="pageRoot">
    <div id="bg" class="pageElement"></div>

    <div id="card">
      <div id="cardContent">
        <h1 id="title01">¿CUÁNDO LLEGA GLOGLOGLO?</h1>

        <h2 id="title02">
          CUANDO APARECEN NUBARRONES.<br />
          CUANDO SE SIENTE OLOR A TIERRA MOJADA.<br />
          CUANDO LOS VECINOS CORREN A ENTRAR LA ROPA.<br />
          SE SIENTE CAER EN LOS TECHOS.
        </h2>
      </div>
    </div>

    <div id="rain" class="pageElement"></div>
    <div id="fox" class="pageElement"></div>
  </div>
</template>
<style scoped>
#title01 {
  position: inherit;
  text-align: center;
  padding-top: 75px;
}
#title02 {
  text-align: center;
}

#rain {
  position: absolute;
  width: 944.03px;
  height: 864.68px;
  left: 53px;
  top: -144px;
  z-index: 2;
  background-image: url(/pages/img/sordoglo/svgGlo1Rain.svg);
}

#bg {
  position: absolute;
  width: 901.1px;
  height: 496.75px;
  left: 38px;
  top: 241px;
  background-image: url(/pages/img/sordoglo/svgGlo2bg.svg);
}

#card {
  position: absolute;
  width: 680px;
  height: 378.43px;
  left: 33px;
  top: 66.53px;
  transform: rotate(-0.54deg);
  z-index: 3;
  background-image: url(/pages/img/sordoglo/svgGlo2Card.svg);
}

#fox {
  position: absolute;
  width: 342.71px;
  height: 293.54px;
  left: 516px;
  top: 390px;
  z-index: 4;
  background-image: url(/pages/img/sordoglo/svgGlo2Fox.svg);
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["glo/Video 2b.mp4"]
    }
  }
}
</script>